import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Menu, MenuItem } from 'react-mdl'

import app from '.././feathers'

import Body from '../Body'
import SearchBar from '../components/SearchBar'
import ConfirmDelete from '../components/ConfirmDelete'

import ImageTable from './ImageTable'
import BulkAction from './components/BulkAction'

const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`

const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  p {
    margin: 5px;
  }
`

const PaginationButton = styled.button`
  width: ${({ width }) => width};
  height: 20px;
  text-align: center;
  vertical-align: middle;
  padding: 0px;
  margin: 5px;
`

const imagesService = app.service('images')
class AssetLibraryScreen extends Component {
  state = {
    searchTerm: '',
    searchingLibrary: false,
    images: [],
    selectedImages: [],
    loading: false,
    page: 0,
    pageSize: 10,
    total: 0,
  }

  static contextTypes = {
    prompt: PropTypes.func,
  }

  async componentDidMount() {
    await this.handleSearch()
  }

  handleSearchChange = searchTerm => {
    this.setState({ searchTerm })
  }

  handleSearch = async () => {
    const { searchTerm, pageSize, page } = this.state
    this.setState({ searchingLibrary: true })
    if (searchTerm !== '') {
      const { total, data: images } = await imagesService.find({
        query: {
          $limit: pageSize,
          $skip: page * pageSize,
          $search: searchTerm,
        },
      })
      this.setState({
        total,
        images,
        searchingLibrary: false,
      })
    } else {
      const { total, data: images } = await imagesService.find({
        query: {
          $limit: pageSize,
          $skip: page * pageSize,
        },
      })
      this.setState({ total, images, searchingLibrary: false })
    }
  }

  handleImageSelect = e => {
    const { selectedImages } = this.state
    const selectedId = e.target.value
    if (selectedImages.includes(selectedId)) {
      const i = selectedImages.indexOf(selectedId)
      this.setState(({ selectedImages }) => ({
        selectedImages: [
          ...selectedImages.slice(0, i),
          ...selectedImages.slice(i + 1),
        ],
      }))
    } else {
      this.setState({ selectedImages: selectedImages.concat(selectedId) })
    }
  }

  handleBulkAction = e => {
    const { selectedImages } = this.state
    const selectedBulkAction = e.target.value
    if (selectedImages.length === 0) {
      alert('Please select assets before choosing a Bulk Action.')
    } else if (selectedBulkAction === 'Delete') {
      this.handleDelete()
    } else if (selectedBulkAction === 'Edit') {
      alert('Insert the bulk editing function.')
    } else {
      alert('You have selected an invalid option.')
    }
  }

  handleDelete = async () => {
    const { selectedImages } = this.state
    const response = await this.context.prompt({
      title: 'Delete Image',
      ContentComponent: ConfirmDelete,
    })
    if (response === 'Delete') {
      this.setState({ loading: true })
      await Promise.all(
        selectedImages.map(image => imagesService.remove(image)),
      )
      this.setState({ selectedImages: [], loading: false })
      await this.handleSearch()
    }
  }

  get totalPages() {
    const { total, pageSize } = this.state
    return Math.ceil(total / pageSize) || 1
  }

  handleChangePageSize = async e => {
    this.setState({ pageSize: e.target.value }, this.handleSearch)
  }

  handleNextPage = () => {
    const { page } = this.state
    if (page + 1 <= this.totalPages) {
      this.setState({ page: page + 1 }, this.handleSearch)
    }
  }

  handlePreviousPage = () => {
    const { page } = this.state
    if (page > 0) {
      this.setState({ page: page - 1 }, this.handleSearch)
    }
  }

  render() {
    const {
      searchTerm,
      searchingLibrary,
      images,
      selectedImages,
      loading,
      page,
      pageSize,
    } = this.state
    const totalPages = this.totalPages
    return (
      <div>
        <Body>
          <h3>Asset Library</h3>
          <ActionsContainer>
            <SearchBar
              onSearch={this.handleSearch}
              onSearchChange={this.handleSearchChange}
              searchTerm={searchTerm}
              searching={searchingLibrary}
            />
          </ActionsContainer>
          <ActionsContainer>
            <BulkAction onBulkAction={this.handleBulkAction} />
            <PaginationContainer>
              <p>Assets per page:</p>
              <PaginationButton id="set-cursor" width="30px">
                {pageSize}
              </PaginationButton>
              <Menu
                target="set-cursor"
                valign="bottom"
                onClick={this.handleChangePageSize}>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
                <MenuItem value={200}>200</MenuItem>
              </Menu>
              <p>
                Page {page + 1} of {totalPages}
              </p>
              <PaginationButton
                disabled={page < 1}
                width="70px"
                onClick={this.handlePreviousPage}>
                Previous
              </PaginationButton>
              <PaginationButton
                disabled={page + 1 >= totalPages}
                width="70px"
                onClick={this.handleNextPage}>
                Next
              </PaginationButton>
            </PaginationContainer>
          </ActionsContainer>
          <ImageTable
            searchingLibrary={searchingLibrary}
            loading={loading}
            images={images}
            selectedImages={selectedImages}
            onImageSelected={this.handleImageSelect}
          />
        </Body>
      </div>
    )
  }
}

export default AssetLibraryScreen



// WEBPACK FOOTER //
// ./src/AssetLibrary/AssetLibraryScreen.js